import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const OrganizationNotificationSettingsWrapper = styled.div`
  margin-bottom: ${Spacing.S32};
  border: 1px solid ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
`
export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${Spacing.S16} ${Spacing.S24};
  cursor: pointer;
`

export const HeaderFigure = styled.figure`
  height: 32px;
`

export const IconWrapper = styled.img`
  width: 32px;
  max-height: 32px;
  border-radius: ${DefaultValue.BorderRadius};
`

export const TextWrapper = styled.div`
  flex-grow: 4;
  padding-left: ${Spacing.S16};
`
